module.exports = __webpack_public_path__ + "static/media/1.e903b8d5.jpg";